import { ChevronDown, FileText } from 'lucide-react';
import { useState } from 'react';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

interface Source {
  title: string;
  url?: string;
  score?: number;
}

interface Chunk {
  text: string;
  score?: number;
}

interface SourcesCardProps {
  sources?: Source[];
  chunks?: Chunk[];
}

export function SourcesCard({ sources, chunks }: SourcesCardProps) {
  const [isOpen, setIsOpen] = useState(true);
  const hasSources = sources && sources.length > 0;
  const hasChunks = chunks && chunks.length > 0;

  if (!hasSources && !hasChunks) return null;

  const totalSources = (sources?.length || 0) + (chunks?.length || 0);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen} className="mt-3">
      <CollapsibleTrigger className="flex items-center gap-2 text-[#002B5B]/70 hover:text-[#002B5B] transition-colors text-sm font-medium group w-full">
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-0' : '-rotate-90'}`} />
        <FileText className="h-4 w-4" />
        <span>Fuentes consultadas ({totalSources})</span>
      </CollapsibleTrigger>
      
      <CollapsibleContent className="mt-2">
        <div className="space-y-1">
          {hasSources && sources.map((source, index) => (
            <div
              key={index}
              className="flex items-start gap-2 text-sm text-[#002B5B]/80 py-1"
            >
              <span className="text-[#002B5B]/40 select-none">•</span>
              <div className="flex-1">
                {source.url ? (
                  <a
                    href={source.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#002B5B]/80 hover:text-[#06D3AA] hover:underline transition-colors"
                  >
                    {source.title}
                  </a>
                ) : (
                  <span>{source.title}</span>
                )}
              </div>
            </div>
          ))}
          
          {hasChunks && chunks.map((chunk, index) => (
            <div
              key={`chunk-${index}`}
              className="flex items-start gap-2 text-sm text-[#002B5B]/80 py-1"
            >
              <span className="text-[#002B5B]/40 select-none">•</span>
              <div className="flex-1 line-clamp-2">
                {chunk.text ? chunk.text.substring(0, 100) + '...' : 'Fragmento de documento'}
              </div>
            </div>
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
